<template>
    <div>
        <component
            :is="resolvedComponent"
            v-if="resolvedComponent"
            :process="process"
            :review-capabilities="reviewCapabilities"
            @item-saved="$emit('item-saved', $event)"
        />

        <b-card v-else>
            <h5 class="mb-1">
                {{ $t('Component(ReviewProcess):unsupported-reviewable-type') }}
            </h5>
            <div>
                <strong>{{ $t('Component(Grid):column-type') }}:</strong>
                <span>{{ reviewableType || '-' }}</span>
            </div>
        </b-card>
    </div>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import DocumentCompliance from './reviewable/DocumentCompliance.vue'

const REVIEWABLE_COMPONENTS = {
    document_compliance: DocumentCompliance,
}

export default {
    name: 'ResearchReviewableRenderer',
    components: {
        BCard,
        DocumentCompliance,
    },
    props: {
        process: {
            type: Object,
            required: true,
        },
        reviewCapabilities: {
            type: Object,
            default: () => ({}),
        },
    },
    computed: {
        reviewableType() {
            return this.process && this.process.reviewableType ? this.process.reviewableType : ''
        },
        resolvedComponent() {
            return REVIEWABLE_COMPONENTS[this.reviewableType] || null
        },
    },
}
</script>
